import { render, staticRenderFns } from "./TelegramChannelDetail.vue?vue&type=template&id=06cc3f3a&scoped=true"
import script from "./TelegramChannelDetail.vue?vue&type=script&lang=js"
export * from "./TelegramChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./TelegramChannelDetail.vue?vue&type=style&index=0&id=06cc3f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc3f3a",
  null
  
)

export default component.exports